<template>
  <g fill-rule="evenodd">
    <path
      d="M15.64 15.7a.88.88 0 01-.64.26.88.88 0 01-.64-.26l-3.32-3.32v-5.4c0-.5.4-.9.9-.9s.9.4.9.9v4.66l2.8 2.8a.9.9 0 010 1.26M12 3a8.99 8.99 0 100 18 8.99 8.99 0 100-18"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TimerIcon",
});
</script>
